/*
 * Ornament PDP mobile sticky add-to-cart bar.
 * Does not reimplement cart logic: it locates the page's real product-form submit button and
 * clicks it, so assets/product-form.js's existing AJAX add / loading state / error handling /
 * cart-drawer open all run exactly as if the shopper tapped the real button.
 * Reveals only once the real button has scrolled out of view; hides again if the shopper scrolls
 * back up to it.
 */
(function () {
  function init() {
    var bar = document.getElementById('ornament-sticky-atc');
    var stickyButton = document.getElementById('ornament-sticky-atc-button');
    if (!bar || !stickyButton) return;

    var form = document.querySelector('product-form form');
    var realButton = form ? form.querySelector('[type="submit"]') : null;

    // No real add-to-cart form found on this page -- never show a button that can't add to cart.
    if (!form || !realButton) return;

    stickyButton.addEventListener('click', function () {
      if (realButton.getAttribute('aria-disabled') === 'true') return;
      realButton.click();
    });

    var mirrorState = function () {
      var disabled = realButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      stickyButton.classList.toggle(
        'ornament-sticky-atc__button--loading',
        realButton.classList.contains('loading')
      );
    };
    mirrorState();
    new MutationObserver(mirrorState).observe(realButton, {
      attributes: true,
      attributeFilter: ['aria-disabled', 'class'],
    });

    // "In view" means the whole real button is on screen. A button peeking a few pixels above the
    // bottom edge is not tappable, so the bar stays up until the real button is fully visible.
    var revealed = false;
    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        var fullyVisible = entry.isIntersecting && entry.intersectionRatio >= 0.98;
        if (!fullyVisible && !revealed) {
          revealed = true;
          bar.hidden = false;
          requestAnimationFrame(function () {
            bar.classList.add('ornament-sticky-atc--visible');
          });
        } else if (fullyVisible && revealed) {
          revealed = false;
          bar.classList.remove('ornament-sticky-atc--visible');
        }
      },
      { threshold: [0, 0.5, 0.98, 1] }
    );
    observer.observe(realButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
